import { GithubRepo } from 'gql/graphql';
import { useTranslations } from 'next-intl';
import { FC } from 'react';
import { useGithubContext } from '../_context/GithubContext';
import DeleteRepository from './DeleteRepository';
import EditRepository from './EditRepository';

interface IExistingRepository {
  repository: GithubRepo;
}

const ExistingRepository: FC<IExistingRepository> = ({ repository }) => {
  const { repoName, id } = repository;
  const { editId, deleteId, setDeleteId, setEditId } = useGithubContext();
  const t = useTranslations();

  const handlerRepositoryToDelete = () => setDeleteId(id);
  const handlerRepositoryToEdit = () => setEditId(id);

  if (editId === id) return <EditRepository repository={repository} />;
  if (deleteId === id) return <DeleteRepository repository={repository} />;

  return (
    <div className="github__sidebox github__sidebox--added_repository">
      <span className="githhub__sidebox__logo ticon-github" />
      <span
        id={`delete-${id}`}
        className="github__sidebox__delete ticon-bin"
        onClick={handlerRepositoryToDelete}
      />
      <span
        id={`edit-${id}`}
        className="github__sidebox__edit ticon-edit"
        onClick={handlerRepositoryToEdit}
      />
      <p>{t('integrations.github.repository')}</p>
      <h3>{repoName}</h3>
    </div>
  );
};

export default ExistingRepository;
